import { BasePolyfill } from './BasePolyfill';

class CustomEventPolyfill extends BasePolyfill {
  public execute = !(typeof (window as any).CustomEvent === 'function');
  public polyfill = () => import('custom-event-polyfill');
}

export { CustomEventPolyfill };
